import { render, staticRenderFns } from "./ImpressoraNova.vue?vue&type=template&id=54d95c3c"
import script from "./ImpressoraNova.vue?vue&type=script&lang=js"
export * from "./ImpressoraNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports